import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactSection = () => {
  const whatsappNumber = '0651988621';
  const formattedNumber = '06 51 98 86 21';

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/33${whatsappNumber?.substring(1)}`, '_blank');
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${whatsappNumber}`;
  };

  return (
    <div className="bg-green-800 rounded-2xl p-8 sm:p-10 text-center">
      <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3">
        Un problème avec votre suivi ? Contactez-nous
      </h3>
      
      <p className="text-green-100 mb-8 max-w-2xl mx-auto">
        Notre équipe est disponible pour répondre à toutes vos questions
      </p>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
        <Button
          variant="default"
          size="lg"
          onClick={handleWhatsAppClick}
          iconName="MessageCircle"
          iconPosition="left"
          className="bg-green-600 hover:bg-green-700 text-white font-semibold shadow-lg"
        >
          WhatsApp
        </Button>
        
        <Button
          variant="outline"
          size="lg"
          onClick={handlePhoneClick}
          iconName="Phone"
          iconPosition="left"
          className="bg-white text-green-800 border-2 border-white hover:bg-green-50 font-semibold"
        >
          {formattedNumber}
        </Button>
      </div>

      <div className="pt-6 border-t border-green-700">
        <p className="text-sm text-green-100">
          <Icon name="Clock" size={16} className="inline mr-2" color="white" />
          Horaires : Lundi-Samedi, 9h-19h
        </p>
      </div>
    </div>
  );
};

export default ContactSection;